<template>
	<div class="grid">
		<FormKit type="text" name="company" label="Maatschappij" />
		<FormKit type="loanlinkCurrency" name="creditLimit" label="KredietLimiet" />
		<FormKit
			type="loanlinkCurrency"
			name="currentOverdraft"
			label="Actuele roodstand"
		/>
		<FormKit type="loanlinkCurrency" name="monthlyAmount" label="Maandbedrag" />
		<FormKit
			type="loanlinkOption"
			name="settledForNewMortgage"
			label="Afgelost voor nieuwe hypotheek"
			:options="{ true: 'Ja', false: 'Nee' }"
		/>
	</div>
</template>
